function getAriaLableList({fields}) {
  try {
    const parsedList = JSON.parse(fields.aria_label_data);
    return parsedList;
  } catch (error) {
    console.error('Failed to parse aria_label_data');
    console.error(error);
    return [];
  }
}

function getCurrenAriaLabel(ariaLabelList, currentFrame, currentAriaLabel) {
  if (ariaLabelList.length) {
    const ariaLabel = ariaLabelList.find((ariaLabelItem) => {
      return (
        ariaLabelItem.fromFrame <= currentFrame &&
        ariaLabelItem.toFrame >= currentFrame
      );
    });
    return ariaLabel;
  } else {
    return currentAriaLabel;
  }
}

function updateSwitchButtons(switchButtons, buttonData) {
  return switchButtons.map((button) => {
    if (button.value === buttonData.value) {
      return {...button, ...buttonData};
    }
    return button;
  });
}

function getUpdatedSliderValue(sliderValue, currentValue) {
  let current = currentValue;
  if (current <= sliderValue.min) current = sliderValue.min;
  if (current >= sliderValue.max) current = sliderValue.max;
  return {...sliderValue, current};
}

function setSliderValueFromAnimation(sliderValue, animation) {
  return {
    ...sliderValue,
    min: animation.firstFrame,
    max: animation.totalFrames - 1,
    current: animation.currentFrame,
  };
}

function getSwitchButtonAriaLabels(data, switchButtons) {
  try {
    const parsedList = data;
    return Object.keys(parsedList).map((valueKey) => {
      let newSwitchButton = switchButtons.find(({value}) => value === valueKey);
      return {...newSwitchButton, ariaLabel: parsedList[valueKey]};
    });
  } catch (error) {
    console.error('Failed to parse aria_label_data');
    console.error(error);
    return switchButtons;
  }
}

export const WIDGETS_UTILS = {
  getAriaLableList,
  getCurrenAriaLabel,
  updateSwitchButtons,
  getUpdatedSliderValue,
  setSliderValueFromAnimation,
  getSwitchButtonAriaLabels,
};
